import ContentLoader from 'react-content-loader';
import PT from 'prop-types';
import styles from './project-card.module.less';

const LoaderProjectCard = (props) => (
    <div className={styles.container}>
        <ContentLoader height={58} width={332} speed={2} primaryColor="#e9e9e9" secondaryColor="#d3d3d3" {...props}>
            <circle cx="33.81" cy="30.89" r="25.28" />
            <rect x="105" y="10" rx="0" ry="0" width="180" height="22" />
            <rect x="105" y="45" rx="0" ry="0" width="70" height="25" />
            <rect x="215" y="45" rx="0" ry="0" width="70" height="25" />
        </ContentLoader>
    </div>
);

LoaderProjectCard.propTypes = {
    animate: PT.bool,
    style: PT.object,
};

LoaderProjectCard.defaultProps = {
    animate: true,
    style: {},
};

export default LoaderProjectCard;
